// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckBox_container__Oiv3L","wContent":"CheckBox_wContent__UogeJ","checked":"CheckBox_checked__jFUzV"};